function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import { Html, Image as ImageComponent } from "@labs/schema";
import clsx from "clsx";
import React from "react";
export default function Image(param) {
    var image = param.image, alt = param.alt, description = param.description;
    return /*#__PURE__*/ React.createElement("div", {
        className: "container-content-wrapper"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "container-text"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "md:mx-[-52px] xl:mx-[-122px]"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mx-0 block"
    }, /*#__PURE__*/ React.createElement("figure", {
        className: "relative block"
    }, /*#__PURE__*/ React.createElement(ImageComponent, _extends({}, image, {
        alt: alt,
        className: clsx("block w-full max-w-full", {})
    })), description ? /*#__PURE__*/ React.createElement("figcaption", {
        className: "block w-full pt-2.5 pl-4 md:pl-0"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "block"
    }, /*#__PURE__*/ React.createElement(Html, {
        markup: description,
        classNames: {
            p: "tiny",
            a: "hover:text-black focus:text-black"
        }
    }))) : null)))));
}
